import { Injectable } from '@angular/core';
import { SharepointConfigurationEntity } from '../../domain/entities/sharepoint-configuration.entity';
import { SharepointConfigurationResponseDto } from '../dtos/sharepoint-configuration-response.dto';

/**
 * Mapper for transforming sharepoint-configuration DTOs to domain entities.
 */
@Injectable({ providedIn: 'root' })
export class SharepointConfigurationsMapper {
  /**
   * Maps a SharePoint configuration DTO to a domain entity.
   * @param dto - SharePoint configuration response DTO
   * @returns SharePoint configuration domain entity
   */
  public toDomain(dto: SharepointConfigurationResponseDto): SharepointConfigurationEntity {
    const entity = new SharepointConfigurationEntity();
    entity.sharepointConfigurationId = dto.sharepointConfigurationId;
    entity.sharepointTenantId = dto.sharepointTenantId;
    entity.clientId = dto.clientId;
    entity.clientSecret = dto.clientSecret;
    entity.baseUrl = dto.baseUrl ?? '';
    entity.automaticFolderCreation = dto.automaticFolderCreation;
    entity.tenantId = dto.tenantId;
    entity.isDeleted = false;
    entity.createdOn = '';
    entity.updatedOn = '';
    return entity;
  }

  /**
   * Maps an array of SharePoint configuration DTOs to domain entities.
   * @param dtos - Array of SharePoint configuration response DTOs
   * @returns Array of SharePoint configuration domain entities
   */
  public toDomainArray(dtos: SharepointConfigurationResponseDto[]): SharepointConfigurationEntity[] {
    return dtos.map((dto) => this.toDomain(dto));
  }
}
